module.exports = __webpack_public_path__ + "img/wild_comming.47af865f.png";